module.exports = __webpack_public_path__ + "img/1492566512.692aff3a.jpg";